<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("app_users") }}
      </h1>
    </div>

    <!-- Add App User Form Section - Disabled: Users will be added from mobile app -->
    <!-- 
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="false"
    >
      <div class="">
        <form @submit.prevent="addAppUserItem" enctype="multipart/form-data">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <BaseInput
              v-model="au_name"
              :label="$t('app_user_name')"
              :placeholder="$t('app_user_name')"
              :rules="rules"
              :isError="checkRulesIsError(au_name, 'add').isError"
              :errorMsg="checkRulesIsError(au_name, 'add').errorMsg"
            />
            <BaseInput
              v-model="au_email"
              :label="$t('app_user_email')"
              :placeholder="$t('app_user_email')"
              type="email"
            />
            <BaseInput
              v-model="au_password"
              :label="$t('app_user_password')"
              :placeholder="$t('app_user_password')"
              type="password"
            />
            <DropdownInput
              v-model="au_type"
              :label="$t('app_user_type')"
              :placeholder="$t('app_user_type')"
              :rules="rules_dropdown"
              :items="[
                { text: 'Facebook', value: 'fb' },
                { text: 'Google', value: 'google' },
                { text: 'Email', value: 'email' },
                { text: 'Apple', value: 'apple' },
              ]"
              :isError="checkRulesIsError(au_type, 'add', this.rules_dropdown).isError"
              :errorMsg="checkRulesIsError(au_type, 'add', this.rules_dropdown).errorMsg"
            />
            <BaseInput
              v-model="au_provider_id"
              :label="$t('app_user_provider_id')"
              :placeholder="$t('app_user_provider_id')"
              :rules="rules"
              :isError="checkRulesIsError(au_provider_id, 'add').isError"
              :errorMsg="checkRulesIsError(au_provider_id, 'add').errorMsg"
            />
            <BaseInput
              v-model="au_phone"
              :label="$t('app_user_phone')"
              :placeholder="$t('app_user_phone')"
            />
            <BaseInput
              v-model="au_city"
              :label="$t('app_user_city')"
              :placeholder="$t('app_user_city')"
            />
            <BaseInput
              v-model="au_address"
              :label="$t('app_user_address')"
              :placeholder="$t('app_user_address')"
            />
            <BaseInput
              v-model="au_token_firebase"
              :label="$t('app_user_firebase_token')"
              :placeholder="$t('app_user_firebase_token')"
            />
            <FileInput
              :label="$t('app_user_image')"
              :placeholder="$t('choose_app_user_image')"
              @change="onChange"
              accept="image/*"
            />
          </div>

          <ButtonInput
            type="button"
            @click="addAppUserItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
    -->
  </div>

  <div
    class="w-full"
    id="printDev"
    v-if="
      $store.getters['checkUserAccess']({
        id: '6',
        action: 'view',
      })
    "
  >
    <div
      :class="
        ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
        ($store.getters['isRtl']
          ? ' md:mr-60 '
          : ' md:ml-60  ')
      "
    >
      <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
        <div class="relative overflow-x-auto mt-4 mb-6">
          <div class="flex items-center justify-between pb-4 mx-5 no-print">
            <div class="flex items-center space-x-4">
              <BaseInput
                :modelValue="search"
                @update:modelValue="handleSearchInput"
                :placeholder="$t('search')"
                :prefixIcon="'fa-solid fa-search'"
                class="w-40 md:w-full"
              />
            </div>
          </div>
          <EasyDataTable
            :headers="headers"
            :items="items"
            :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
            :alternating="false"
            :buttons-pagination="true"
            :loading="isLoadingData"
            :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
            :server-items-length="serverItemsLength"
            :server-options="serverOptions"
            @update:server-options="loadFromServer"
          >
            <template #default="{ column, sortDirection }">
              <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
                <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
                <span v-if="column.sortable" class="text-gray-400">
                  <i
                    v-if="sortDirection === 'asc'"
                    class="fa-solid fa-arrow-up text-blue-500"
                  ></i>
                  <i
                    v-else-if="sortDirection === 'desc'"
                    class="fa-solid fa-arrow-down text-blue-500"
                  ></i>
                  <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
                </span>
              </div>
            </template>
            <template #item-actions="item">
              <button
                class="mx-1 my-1"
                @click="showModal(item)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '6',
                    action: 'edit',
                  })
                "
              >
                <i
                  class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
                ></i>
              </button>
              <button
                class="mx-1 my-1"
                @click="showNotificationModal(item)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '33',
                    action: 'add',
                  })
                "
                :title="$t('send_notification')"
              >
                <i
                  class="fa-solid fa-bell text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-green-300 rounded-md text-green-500 mx-auto"
                ></i>
              </button>
              <button
                class="mx-1 my-1"
                @click="deleteItem(item.au_id)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '6',
                    action: 'delete',
                  })
                "
              >
                <i
                  class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
                ></i>
              </button>
            </template>

            <template #item-au_image="item">
              <img
                :src="file_url + item.au_image"
                class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out h-16 w-16 rounded-xl object-cover cursor-pointer"
                alt="App User Image"
                v-if="item.au_image"
                @click="openModal(file_url + item.au_image)"
              />
              <span v-if="!item.au_image || item.au_image == ''">
                <i class="fa-solid fa-image text-primaryColor"></i>
              </span>
            </template>
            <template #item-au_note="item">
              <span
                class="text-gray-700 dark:text-gray-300 max-w-xs truncate block"
                :title="item.au_note || ''"
              >
                {{ item.au_note || '-' }}
              </span>
            </template>
            <template #loading>
              <div class="flex items-center justify-center py-8">
                <img
                  src="../../assets/loading.webp"
                  class="w-16 h-16 animate-pulse"
                  alt="Loading..."
                />
              </div>
            </template>
            <template #item-created_at="item">
              {{ formatDate(item.created_at) }}
            </template>
            <template #empty-message>
              <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
                <i class="fa-solid fa-inbox text-4xl mb-4"></i>
                <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
              </div>
            </template>
            <template
              #pagination="{
                prevPage,
                nextPage,
                isFirstPage,
                isLastPage,
                currentPaginationNumber,
                maxPaginationNumber,
              }"
            >
              <button :disabled="isFirstPage" @click="goToPage(1)">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-right'
                      : ' fa-angle-double-left')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button :disabled="isFirstPage" @click="prevPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-right'
                      : ' fa-angle-left ')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                v-for="page in getVisiblePages(
                  currentPaginationNumber,
                  maxPaginationNumber
                )"
                :key="page"
                @click="goToPage(page)"
                :class="getPageButtonClasses(page, currentPaginationNumber)"
              >
                {{ page }}
              </button>

              <div class="w-5"></div>
              <button :disabled="isLastPage" @click="nextPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-left'
                      : ' fa-angle-right')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                :disabled="isLastPage"
                @click="goToPage(maxPaginationNumber)"
              >
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-left'
                      : ' fa-angle-double-right')
                  "
                ></i>
              </button>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit.prevent="editItem">
        <BaseInput
          v-model="current.au_name"
          :label="$t('app_user_name')"
          :placeholder="$t('app_user_name')"
          :rules="rules"
          :isError="checkRulesIsError(current.au_name, 'edit').isError"
          :errorMsg="checkRulesIsError(current.au_name, 'edit').errorMsg"
        />
        <BaseInput
          v-model="current.au_email"
          :label="$t('app_user_email')"
          :placeholder="$t('app_user_email')"
          type="email"
        />
        <BaseInput
          v-model="current.au_password"
          :label="$t('app_user_password')"
          :placeholder="$t('app_user_password')"
          type="password"
        />
        <DropdownInput
          v-model="current.au_type"
          :label="$t('app_user_type')"
          :placeholder="$t('app_user_type')"
          :rules="rules_dropdown"
          :items="[
            { text: 'Facebook', value: 'fb' },
            { text: 'Google', value: 'google' },
            { text: 'Email', value: 'email' },
            { text: 'Apple', value: 'apple' },
          ]"
          :isError="checkRulesIsError(current.au_type, 'edit', this.rules_dropdown).isError"
          :errorMsg="checkRulesIsError(current.au_type, 'edit', this.rules_dropdown).errorMsg"
        />
        <BaseInput
          v-model="current.au_provider_id"
          :label="$t('app_user_provider_id')"
          :placeholder="$t('app_user_provider_id')"
          :rules="rules"
          :isError="checkRulesIsError(current.au_provider_id, 'edit').isError"
          :errorMsg="checkRulesIsError(current.au_provider_id, 'edit').errorMsg"
        />
        <BaseInput
          v-model="current.au_phone"
          :label="$t('app_user_phone')"
          :placeholder="$t('app_user_phone')"
        />
        <BaseInput
          v-model="current.au_city"
          :label="$t('app_user_city')"
          :placeholder="$t('app_user_city')"
        />
        <BaseInput
          v-model="current.au_address"
          :label="$t('app_user_address')"
          :placeholder="$t('app_user_address')"
        />
        <BaseInput
          v-model="current.au_token_firebase"
          :label="$t('app_user_firebase_token')"
          :placeholder="$t('app_user_firebase_token')"
        />
        <FileInput
          :label="$t('app_user_image')"
          :placeholder="$t('choose_app_user_image')"
          @change="onChangeEdit"
          accept="image/*"
        />
        <div v-if="current.au_image" class="mt-2">
          <img
            :src="file_url + current.au_image"
            class="h-20 w-20 rounded object-cover"
            alt="Current App User Image"
          />
        </div>
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
  <edit-modal ref="notificationModal">
    <div class="items-center">
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {{ $t("send_notification") }} - {{ selectedUserForNotification?.au_name }}
      </h2>
      <form @submit.prevent="sendNotificationToUser">
        <BaseInput
          v-model="notificationTitle"
          :label="$t('notification_title')"
          :placeholder="$t('notification_title')"
          :rules="rules"
          :isError="isNotificationSubmited && checkRulesIsError(notificationTitle, 'notification').isError"
          :errorMsg="isNotificationSubmited ? checkRulesIsError(notificationTitle, 'notification').errorMsg : ''"
        />
        <div class="my-3">
          <TextAreaInput
            v-model="notificationDescription"
            :label="$t('notification_description')"
            :placeholder="$t('notification_description')"
            :rules="rules"
            :isError="isNotificationSubmited && checkRulesIsError(notificationDescription, 'notification').isError"
            :errorMsg="isNotificationSubmited ? checkRulesIsError(notificationDescription, 'notification').errorMsg : ''"
          />
        </div>
        <DropdownInput
          v-model="notificationAction"
          :label="$t('notification_action')"
          :placeholder="$t('notification_action')"
          :items="[
            { id: 'link', value: 'link' },
            { id: 'phone number', value: 'phone number' },
            { id: 'perfume', value: $t('perfume') || 'perfume' },
            { id: 'none', value: 'none' },
          ]"
        />
        <BaseInput
          v-if="notificationAction && notificationAction !== 'none' && notificationAction !== 'perfume'"
          v-model="notificationActionData"
          :label="notificationAction === 'link' ? $t('link') : $t('phone_number')"
          :placeholder="notificationAction === 'link' ? $t('link') : $t('phone_number')"
          class="my-3"
        />
        <div v-if="notificationAction === 'perfume'" class="my-3">
          <label class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1">
            {{ $t('select_perfume') || 'Select Perfume' }}
          </label>
          <div ref="perfumeSearchContainer" class="relative">
            <BaseInput
              v-model="perfumeSearchTerm"
              :placeholder="$t('search_perfume') || 'Search perfume...'"
              :prefixIcon="'fa-solid fa-search'"
              @update:modelValue="onPerfumeSearch"
              @focus="showPerfumeDropdown = true"
            />
            <!-- Dropdown Results -->
            <Transition
              enter-active-class="transition duration-200 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-150 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <div
                v-if="showPerfumeDropdown && (perfumeOptions.length > 0 || isLoadingPerfumes)"
                class="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-60 overflow-y-auto"
              >
                <div v-if="isLoadingPerfumes" class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center">
                  <i class="fa fa-spinner fa-spin mr-2"></i>
                  {{ $t('loading') || 'Loading...' }}
                </div>
                <div
                  v-else
                  v-for="perfume in perfumeOptions"
                  :key="perfume.id"
                  @click="selectPerfume(perfume)"
                  class="px-3 py-2 text-sm cursor-pointer transition-colors duration-150 text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  {{ perfume.value }}
                </div>
                <div
                  v-if="!isLoadingPerfumes && perfumeOptions.length === 0 && perfumeSearchTerm"
                  class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center"
                >
                  {{ $t('no_data_found') || 'No perfumes found' }}
                </div>
              </div>
            </Transition>
            <!-- Selected Perfume Display -->
            <div v-if="selectedPerfumeName" class="mt-2 px-3 py-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
              <div class="flex items-center justify-between">
                <span class="text-sm text-blue-900 dark:text-blue-200">
                  <i class="fa fa-check-circle mr-2"></i>
                  {{ selectedPerfumeName }}
                </span>
                <button
                  @click="clearPerfumeSelection"
                  class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                  type="button"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <center>
          <ButtonInput
            type="submit"
            :label="$t('send_notification')"
            :isLoading="isNotificationLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
  <image-modal ref="imageModal"></image-modal>
</template>
<script>
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";
import "../../assets/css/modern-table.css";

export default {
  name: "APP_USER",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    FileInput,
    DropdownInput,
    TextAreaInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    ImageModal,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;
          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;
          return this.$t("you_must_fill_this_field");
        },
      ],
      au_name: "",
      au_email: "",
      au_password: "",
      au_type: "",
      au_provider_id: "",
      au_phone: "",
      au_city: "",
      au_address: "",
      au_token_firebase: "",
      file: null,
      fileEdit: null,
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      file_url: this.$store.getters.fileUrl,
      search: "",
      serverOptions: {
        page: 1,
        rowsPerPage: 15,
        sortBy: "au_id",
        sortType: "desc",
      },
      serverItemsLength: 0,
      notificationLoadingUsers: [],
      selectedUserForNotification: null,
      notificationTitle: "",
      notificationDescription: "",
      notificationAction: "",
      notificationActionData: "",
      isNotificationSubmited: false,
      isNotificationLoading: false,
      selectedPerfumeId: "",
      selectedPerfumeName: "",
      perfumeOptions: [],
      perfumeSearchTerm: "",
      isLoadingPerfumes: false,
      perfumeSearchTimeout: null,
      showPerfumeDropdown: false,
    };
  },
  created() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "6",
        action: "view",
      })
    ) {
      this.loadFromServer(this.serverOptions);
    }
    // Add click outside handler for perfume dropdown
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // Remove click outside handler
    document.removeEventListener('click', this.handleClickOutside);
    // Clear timeouts
    if (this.perfumeSearchTimeout) {
      clearTimeout(this.perfumeSearchTimeout);
    }
  },
  watch: {
    getResultDialog(newValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.app_user.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.app_user.isSuccess,
        });
        this.$store.commit("app_user/SET_DELETE_SUCCESS", false);
      }
    },
    notificationAction(newValue) {
      if (newValue === 'perfume') {
        // Don't load perfumes automatically - wait for user to search
        this.showPerfumeDropdown = false;
        this.perfumeOptions = [];
      } else {
        // Clear perfume selection when switching to other actions
        this.selectedPerfumeId = "";
        this.selectedPerfumeName = "";
        this.perfumeOptions = [];
        this.perfumeSearchTerm = "";
        this.showPerfumeDropdown = false;
      }
    },
  },
  computed: {
    getResultDialog() {
      return this.$store.state.app_user.isShowResultDialog;
    },
    items() {
      return this.$store.state.app_user.items;
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.app_user.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.app_user.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.app_user.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "au_id", sortable: true },
        {
          text: this.$t("app_user_name"),
          value: "au_name",
          sortable: true,
        },
        {
          text: this.$t("app_user_email"),
          value: "au_email",
          sortable: true,
        },
        {
          text: this.$t("app_user_type"),
          value: "au_type",
          sortable: true,
        },
        {
          text: this.$t("app_user_phone"),
          value: "au_phone",
          sortable: true,
        },
        {
          text: this.$t("app_user_city"),
          value: "au_city",
          sortable: true,
        },
        {
          text: this.$t("note"),
          value: "au_note",
          sortable: true,
        },
        {
          text: this.$t("app_user_image"),
          value: "au_image",
          sortable: false,
        },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    async loadFromServer(options) {
      const response = await this.$store.dispatch("app_user/getItems", {
        page: options.page,
        rowsPerPage: options.rowsPerPage,
        search: this.search,
        sortBy: options.sortBy,
        sortType: options.sortType,
      });
      if (response && response.data) {
        this.serverItemsLength = response.data.total || 0;
        this.serverOptions = { ...this.serverOptions, ...options };
      }
    },
    goToPage(page) {
      this.serverOptions.page = page;
      this.loadFromServer(this.serverOptions);
    },
    getVisiblePages(current, max) {
      const pages = [];
      const start = Math.max(1, current - 2);
      const end = Math.min(max, current + 2);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    getPageButtonClasses(page, current) {
      return page === current
        ? "px-3 py-1 bg-blue-500 text-white rounded"
        : "px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-300 dark:hover:bg-gray-600";
    },
    handleSearchInput(value) {
      this.search = value;
      this.serverOptions.page = 1;
      this.loadFromServer(this.serverOptions);
    },
    onChange(files) {
      this.file = files[0] || null;
    },
    onChangeEdit(files) {
      this.fileEdit = files[0] || null;
    },
    openModal(imageUrl) {
      this.$refs.imageModal.show(imageUrl);
    },
    async addAppUserItem(e) {
      e.preventDefault();
      if (this.$store.state.app_user.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.au_name, "add").isError ||
        this.checkRulesIsError(this.au_type, "add", this.rules_dropdown).isError ||
        this.checkRulesIsError(this.au_provider_id, "add").isError
      ) {
        return;
      }
      this.$store.state.app_user.isBtnLoading = true;
      var res = await this.$store.dispatch("app_user/addNewItem", {
        au_name: this.au_name,
        au_email: this.au_email,
        au_password: this.au_password,
        au_type: this.au_type,
        au_provider_id: this.au_provider_id,
        au_phone: this.au_phone,
        au_city: this.au_city,
        au_address: this.au_address,
        au_token_firebase: this.au_token_firebase,
        file: this.file,
      });
      if (res.status == 200) {
        this.au_name = "";
        this.au_email = "";
        this.au_password = "";
        this.au_type = "";
        this.au_provider_id = "";
        this.au_phone = "";
        this.au_city = "";
        this.au_address = "";
        this.au_token_firebase = "";
        this.file = null;
        this.isSubmited = false;
        this.$store.state.app_user.isBtnLoading = false;
        this.loadFromServer(this.serverOptions);
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules = null) {
      var isError = false;
      var errorMsg = "";
      const rulesToCheck = rules || this.rules;
      
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "notification") {
        if (this.isNotificationSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rulesToCheck) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("app_user/REMOVE_ITEM", id);
        this.$store.dispatch("app_user/deleteItem", id);
        this.loadFromServer(this.serverOptions);
      }
    },
    async showModal(item) {
      this.current = { ...item };
      this.fileEdit = null;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.au_name, "edit").isError ||
        this.checkRulesIsError(this.current.au_type, "edit", this.rules_dropdown).isError ||
        this.checkRulesIsError(this.current.au_provider_id, "edit").isError
      ) {
        return;
      }
     
      this.$store.state.app_user.isBtnEditLoading = true;
      var res = await this.$store.dispatch("app_user/editItem", {
        au_id: this.current.au_id,
        au_name: this.current.au_name,
        au_email: this.current.au_email,
        au_password: this.current.au_password,
        au_type: this.current.au_type,
        au_provider_id: this.current.au_provider_id,
        au_phone: this.current.au_phone,
        au_city: this.current.au_city,
        au_address: this.current.au_address,
        au_token_firebase: this.current.au_token_firebase,
        file: this.fileEdit,
      });

      this.isSubmitedEdit = false;
      this.$store.state.app_user.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.fileEdit = null;
        this.loadFromServer(this.serverOptions);
      }
    },
    async showNotificationModal(user) {
      this.selectedUserForNotification = user;
      this.notificationTitle = "";
      this.notificationDescription = "";
      this.notificationAction = "";
      this.notificationActionData = "";
      this.selectedPerfumeId = "";
      this.selectedPerfumeName = "";
      this.perfumeOptions = [];
      this.perfumeSearchTerm = "";
      this.showPerfumeDropdown = false;
      this.isNotificationSubmited = false;
      await this.$refs.notificationModal.show();
    },
    async loadPerfumes(searchTerm = "") {
      try {
        this.isLoadingPerfumes = true;
        const response = await this.$store.dispatch("item_list/getItems", {
          page: 1,
          rowsPerPage: 50,
          search: searchTerm || "",
          sortBy: 'i_id',
          sortType: 'desc',
        });
        
        if (response && response.data && response.data.items) {
          const items = response.data.items.data || [];
          this.perfumeOptions = items
            .filter(item => item.i_barcode && item.i_barcode.trim() !== '') // Only include items with barcode
            .map(item => ({
              id: item.i_barcode, // Use barcode as ID since API expects barcode
              value: `${item.i_name}${item.i_barcode ? ' (' + item.i_barcode + ')' : ''}`,
              i_id: item.i_id, // Keep i_id for reference
              i_barcode: item.i_barcode
            }));
        } else {
          this.perfumeOptions = [];
        }
      } catch (error) {
        console.error("Error loading perfumes:", error);
        this.perfumeOptions = [];
      } finally {
        this.isLoadingPerfumes = false;
      }
    },
    onPerfumeSearch(value) {
      // Clear previous timeout
      if (this.perfumeSearchTimeout) {
        clearTimeout(this.perfumeSearchTimeout);
      }
      
      // Show dropdown when user starts typing
      if (value && value.length > 0) {
        this.showPerfumeDropdown = true;
      }
      
      // Debounce search - wait 500ms after user stops typing
      this.perfumeSearchTimeout = setTimeout(() => {
        if (value && value.trim().length > 0) {
          this.loadPerfumes(value.trim());
        } else {
          // If search is empty, clear results
          this.perfumeOptions = [];
          this.showPerfumeDropdown = false;
        }
      }, 500);
    },
    selectPerfume(perfume) {
      this.selectedPerfumeId = perfume.id; // This is the barcode
      this.selectedPerfumeName = perfume.value;
      // Store barcode in notificationActionData since API expects barcode, not i_id
      this.notificationActionData = perfume.i_barcode || perfume.id.toString();
      this.perfumeSearchTerm = "";
      this.showPerfumeDropdown = false;
      this.perfumeOptions = [];
    },
    clearPerfumeSelection() {
      this.selectedPerfumeId = "";
      this.selectedPerfumeName = "";
      this.notificationActionData = "";
      this.perfumeSearchTerm = "";
      this.showPerfumeDropdown = false;
      this.perfumeOptions = [];
    },
    handleClickOutside(event) {
      // Close perfume dropdown if clicking outside
      if (this.showPerfumeDropdown && this.$refs.perfumeSearchContainer && 
          !this.$refs.perfumeSearchContainer.contains(event.target)) {
        this.showPerfumeDropdown = false;
      }
    },
    async sendNotificationToUser(e) {
      e.preventDefault();
      const t = i18n.global.t;
      
      this.isNotificationSubmited = true;

      // Validate
      if (
        this.checkRulesIsError(this.notificationTitle, "notification").isError ||
        this.checkRulesIsError(this.notificationDescription, "notification").isError
      ) {
        return;
      }

      if (this.notificationAction && this.notificationAction !== "none") {
        if (this.notificationAction === "perfume" && !this.selectedPerfumeId) {
          toast("error", t("please_select_perfume") || "Please select a perfume");
          return;
        } else if (this.notificationAction !== "perfume" && !this.notificationActionData) {
          toast("error", t("please_fill_all_fields"));
          return;
        }
      }

      this.isNotificationLoading = true;

      try {
        await this.$store.dispatch("notification/sendNotification", {
          user_id: this.selectedUserForNotification.au_id,
          title: this.notificationTitle.trim(),
          description: this.notificationDescription.trim(),
          no_action: this.notificationAction || null,
          no_action_data: this.notificationAction === 'perfume' ? this.selectedPerfumeId.toString() : (this.notificationActionData || null),
        });

        // Reset form
        this.notificationTitle = "";
        this.notificationDescription = "";
        this.notificationAction = "";
        this.notificationActionData = "";
        this.selectedPerfumeId = "";
        this.selectedPerfumeName = "";
        this.perfumeOptions = [];
        this.perfumeSearchTerm = "";
        this.showPerfumeDropdown = false;
        this.isNotificationSubmited = false;
        this.selectedUserForNotification = null;

        // Close modal
        this.$refs.notificationModal.hide();
      } catch (error) {
        console.error("Error sending notification:", error);
      } finally {
        this.isNotificationLoading = false;
      }
    },
  },
};
</script>
